export default {
  cartList: {
    status: 0,
    data: [],
  },
};
